import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconListBullets: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconListBullets"><Path d="M8 6.5L21 6.5" stroke="currentColor"/><Circle cx="4" cy="6.5" r="1" fill="currentColor"/><Path d="M8 12L21 12" stroke="currentColor"/><Circle cx="4" cy="12" r="1" fill="currentColor"/><Path d="M8 17.5L21 17.5" stroke="currentColor"/><Circle cx="4" cy="17.5" r="1" fill="currentColor"/></CentralIconBase>;
});

export default IconListBullets;
